import React from 'react';
import { Tag } from 'antd';
import { MdOutlineInventory2, MdOutlineDesignServices, MdOutlineWidgets } from 'react-icons/md';

interface ProductTypeProps {
  name: string;
}

interface TypeConfig {
  label: string;
  icon: React.ReactNode;
  color: string;
  bg: string;
  border: string;
}

// goods / services / combos — mỗi loại 1 icon + màu để nhận biết nhanh trong bảng.
const TYPE_MAP: Record<string, TypeConfig> = {
  goods: { label: 'Hàng hoá', icon: <MdOutlineInventory2 />, color: '#0f766e', bg: '#e6f4f2', border: '#b7ddd7' },
  services: { label: 'Dịch vụ', icon: <MdOutlineDesignServices />, color: '#2563eb', bg: '#eaf1ff', border: '#c3d7ff' },
  combos: { label: 'Combo', icon: <MdOutlineWidgets />, color: '#b45309', bg: '#fdf1e3', border: '#f3d3ab' },
};

const ProductType: React.FC<ProductTypeProps> = ({ name }) => {
  const cfg = TYPE_MAP[name] ?? TYPE_MAP.goods;

  return (
    <Tag
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        margin: 0,
        padding: '2px 9px',
        borderRadius: 12,
        fontWeight: 500,
        color: cfg.color,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
      }}
    >
      <span style={{ display: 'inline-flex', fontSize: 14 }}>{cfg.icon}</span>
      {cfg.label}
    </Tag>
  );
};

export default ProductType;
